import React, { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Input, Button, Modal, Row, Col, Upload, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { UPLOAD_CSV } from "reducers/reducer";
import { RcFile } from "rc-upload/lib/interface";
import { RootState } from "reducers/rootReducer";
import { useLocation } from "react-router-dom";
import  CPCDashboard  from '../../CPC/Dashboard'

const { Option } = Select;

const CPCModal: FC<{
  socket?: ISocket;
  onClose?: () => void;
  start?: Date;
  selectedCustomerId?: string;
  selectedProjectId?: string;
  onEventCreated?: any
}> = ({ onClose, socket, start, onEventCreated, selectedCustomerId, selectedProjectId }) => {
  const [isModalVisible, setIsModalVisible] = useState<boolean>(true);
  const [saving, setSaving] = useState<boolean>(false);
  const [file, setFile] = useState<RcFile>();
  const [location, setLocation] = useState<any>();
  const { projects, csvToSend } = useSelector((state: RootState) => state.auth);
  const { userBds } = useSelector((state: RootState) => state.auth);
  const [selectedProject, setSelectedProject] = useState<any>();
  const { search } = useLocation();

  const handleCancel = () => {
    setIsModalVisible(false);
    onClose && onClose();
  };
  const dispatch = useDispatch();
  const handleOk = () => {
    const query = new URLSearchParams(search);
    const userId = query.get("userId");
    const pageExtendedBio = {};
    projects?.sections.forEach((bio: any) => {
      return bio.Rows.forEach((row: any) => {
        row.Cols.forEach((col: any) => {
          if (col?.type === "location" || col?.type.includes("location")) {
            pageExtendedBio[`${col?.name}-lat`] = "";
            pageExtendedBio[`${col?.name}-long`] = "";
          } else {
            pageExtendedBio[col?.name] = "";
          }
        });
      });
    });
    let form = new FormData();
    form.append("file", file);
    form.append("projectId", JSON.stringify(selectedProject));
    form.append("dispatcherUserId", JSON.stringify(userId));
    form.append("isExecute", JSON.stringify(true));
    form.append(
      "adminUser",
      JSON.stringify({
        cudbServiceId: projects?.userServiceId,
      })
    );
    form.append(
      "basicFieldsName",
      JSON.stringify({
        title: "",
        "location-lat": "",
        "location-long": "",
      })
    );
    form.append("extendedFieldsName", JSON.stringify(pageExtendedBio));
    dispatch(UPLOAD_CSV({ form }));
    setSaving(true);
  };

  useEffect(() => {
    setSaving(false);
  }, [csvToSend]);

  return (
    <Modal
      title="Event creator"
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width="80vw"
      className="beam-modal"
      footer={[]}
      destroyOnClose={true}
    >
      <CPCDashboard socket={socket} date={start} selectedCustomerId={selectedCustomerId} onEventCreated={onEventCreated} selectedProjectId={selectedProjectId} />
    </Modal>
  );
};

export default CPCModal;
